"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("./index.css");

var _mwNumberAlignment = require("./mw-number-alignment");

var _arrowDown = _interopRequireDefault(require("./assets/arrow-down.svg"));

var _arrowUp = _interopRequireDefault(require("./assets/arrow-up.svg"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _htmlShortNumberFormatter = _interopRequireDefault(require("../label-formatters/html-short-number-formatter"));

var _logger = _interopRequireDefault(require("../logger"));

var _mwNumberDeltaOptions = _interopRequireDefault(require("./mw-number-delta-options"));

var _numberDeltaData = _interopRequireDefault(require("../number-delta-data"));

var _percentageFormatter = _interopRequireDefault(require("../label-formatters/percentage-formatter"));

var _responsiveStyleManager = require("../responsive-style-manager");

var LESS_THAN_ONE_PERCENT = '&lt;1%';
var STYLE_CONTAINER_NO_DELTA = 'mw-number-delta__delta-container--no-delta';
var STYLE_DELTA_ALIGN_CENTER = 'mw-number-delta__container--align-center';
var STYLE_DELTA_ALIGN_RIGHT = 'mw-number-delta__container--align-right';
var STYLE_DELTA_ARROW = 'mw-number-delta__arrow';
var STYLE_DELTA_POSITIVE = 'mw-number-delta__delta-container--delta-positive';
var STYLE_DELTA_NEGATIVE = 'mw-number-delta__delta-container--delta-negative';
var STYLE_DELTA_NO_DELTA_VALUE = 'mw-number-delta__delta-value--no-delta-value';
var STYLE_NUMBER_NO_DELTA = 'mw-number-delta__number--no-delta';
/**
 * A class for rendering a number and delta
 * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
 */

var MwNumberDelta =
/*#__PURE__*/
function () {
  function MwNumberDelta(renderTarget) {
    (0, _classCallCheck2.default)(this, MwNumberDelta);
    var renderTargetElement;

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    if (typeof renderTarget === 'string') {
      renderTargetElement = document.getElementById(renderTarget);

      if (!renderTargetElement) {
        throw new TypeError("renderTarget string is invalid. Provided value: ".concat(renderTarget));
      }
    } else if (typeof renderTarget.innerHTML !== 'string') {
      throw new TypeError("renderTarget.innerHTML string is invalid. Provided value: ".concat(renderTarget));
    } else {
      renderTargetElement = renderTarget;
    }

    this.__data = null;
    this.__options = new _mwNumberDeltaOptions.default({});
    this.__renderTarget = renderTargetElement;
    this.__responsiveStyleManager = new _responsiveStyleManager.ResponsiveStyleManager();
  }
  /**
   * Set the visualization data to be rendered
   * @param {NumberDeltaData} numberData - The data to be rendered to the visualization
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwNumberDelta, [{
    key: "setData",
    value: function setData(numberData) {
      this.__data = (0, _coerce.default)(numberData, _numberDeltaData.default, "data should be shaped like a NumberDeltaData class. Provided value: ".concat(JSON.stringify(numberData)));
    }
    /**
     * @deprecated until v8
     * Set the visualization options for the chart
     * @param {MwNumberDeltaOptions} options - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(options) {
      _logger.default.warn('MwNumberDelta.setChartOptions is deprecated. Please use MwNumberDelta.setOptions.');

      this.setOptions(options);
    }
    /**
     * Set the visualization options for the chart
     * @param {MwNumberDeltaOptions} options - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.__options = (0, _coerce.default)(options, _mwNumberDeltaOptions.default, "options should be shaped like a MwNumberDeltaOptions. Provided value: ".concat(JSON.stringify(_mwNumberDeltaOptions.default)));
    }
    /**
     * Clean up when the chart is no longer needed.
     * This is required to lessen performance load when the element is removed from the DOM.
     * @returns {undefined}
     */

  }, {
    key: "remove",
    value: function remove() {
      if (this.__registrationId) {
        this.__responsiveStyleManager.unregister(this.__registrationId);

        delete this.__registrationId;
      }
    }
    /**
     * Render the number and delta to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      if (this.__data === null) {
        throw new TypeError("Data was not set before render was called. Provided value: ".concat(JSON.stringify(this.__data)));
      }

      var deltaAlignmentStyle = '';
      var deltaArrow = '';
      var deltaArrowStyle = '';
      var deltaStyle = '';
      var deltaValueStyle = '';
      var numberStyle = '';
      var containerNoDeltaStyle = '';
      var deltaDisplayValue = '';
      var deltaUnits = '';

      if (this.__data.isDeltaInfinity) {
        deltaArrow = _arrowUp.default;
        deltaArrowStyle = STYLE_DELTA_ARROW;
        deltaStyle = STYLE_DELTA_POSITIVE;
        deltaValueStyle = STYLE_DELTA_NO_DELTA_VALUE;
      } else if (this.__data.delta > 1) {
        deltaArrow = _arrowUp.default;
        deltaArrowStyle = STYLE_DELTA_ARROW;
        deltaStyle = STYLE_DELTA_POSITIVE;
        deltaDisplayValue = "".concat((0, _percentageFormatter.default)(Math.abs(this.__data.delta)), "%");
      } else if (this.__data.delta > 0 && this.__data.delta < 1) {
        deltaArrow = _arrowUp.default;
        deltaArrowStyle = STYLE_DELTA_ARROW;
        deltaStyle = STYLE_DELTA_POSITIVE;
        deltaDisplayValue = LESS_THAN_ONE_PERCENT;
      } else if (this.__data.delta < 0 && this.__data.delta > -1) {
        deltaArrow = _arrowDown.default;
        deltaArrowStyle = STYLE_DELTA_ARROW;
        deltaStyle = STYLE_DELTA_NEGATIVE;
        deltaDisplayValue = LESS_THAN_ONE_PERCENT;
      } else if (this.__data.delta < -1) {
        deltaArrow = _arrowDown.default;
        deltaArrowStyle = STYLE_DELTA_ARROW;
        deltaStyle = STYLE_DELTA_NEGATIVE;
        deltaDisplayValue = "".concat((0, _percentageFormatter.default)(Math.abs(this.__data.delta)), "%");
      } else if (this.__data.isDeltaNaN) {
        containerNoDeltaStyle = STYLE_CONTAINER_NO_DELTA;
        numberStyle = STYLE_NUMBER_NO_DELTA;
        deltaStyle = STYLE_DELTA_NEGATIVE;
      } else if (this.__data.delta === 0) {
        deltaDisplayValue = '0%';
      } else {
        throw new Error("We could not successfully create the template to render based on the data provided. Provided value: ".concat(JSON.stringify(this.__data)));
      }

      if (this.__options.unit !== '') {
        deltaUnits = "<div class=\"mw-number-delta__delta-units\">".concat(this.__options.unit, "</div>");
      }

      if (this.__options.align === _mwNumberAlignment.Alignment.CENTER) {
        deltaAlignmentStyle = STYLE_DELTA_ALIGN_CENTER;
      } else if (this.__options.align === _mwNumberAlignment.Alignment.RIGHT) {
        deltaAlignmentStyle = STYLE_DELTA_ALIGN_RIGHT;
      }

      this.remove();
      this.__registrationId = this.__responsiveStyleManager.register({
        element: this.__renderTarget,
        breakpointStyles: [{
          className: 'mwv-medium-breakpoint',
          minWidth: 230
        }]
      });
      this.__renderTarget.innerHTML = "\n            <div class=\"mw-number-delta__container ".concat(deltaAlignmentStyle, "\">\n                <div class=\"mw-number-delta__container-child\">\n                    <div class=\"mw-number-delta__number ").concat(numberStyle, "\">").concat((0, _htmlShortNumberFormatter.default)(this.__data.number), "</div>\n                    ").concat(deltaUnits, "\n                    <div class=\"mw-number-delta__delta-container ").concat(containerNoDeltaStyle, " ").concat(deltaStyle, "\">\n                        <div class=\"").concat(deltaArrowStyle, "\">\n                            ").concat(deltaArrow, "\n                        </div>\n                        <div class=\"mw-number-delta__delta-value ").concat(deltaValueStyle, "\">").concat(deltaDisplayValue, "</div>\n                    </div>\n                </div>\n            </div>\n        ");
    }
  }]);
  return MwNumberDelta;
}();

exports.default = MwNumberDelta;